import { render, staticRenderFns } from "./ForumHeader.vue?vue&type=template&id=f27d7536&scoped=true&"
import script from "./ForumHeader.vue?vue&type=script&lang=js&"
export * from "./ForumHeader.vue?vue&type=script&lang=js&"
import style0 from "./ForumHeader.vue?vue&type=style&index=0&id=f27d7536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27d7536",
  null
  
)

export default component.exports